import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { ImageModalCircle } from '../assets/ImageModalCircle';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { redirectGolEnviroment } from '../utils/redirectEnviroment';

export function AccountUnderReviewModal() {
  const { t } = useTranslation('modais');

  const [searchParams] = useSearchParams();
  const sourceAccess = searchParams.get('src')?.toLowerCase() || 'smiles';
  const sourceIsGolBrand = sourceAccess === 'gol';

  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.ACCOUNT_UNDER_REVIEW);
  }

  function redirectToHome() {
    const golUrl = redirectGolEnviroment();

    if(sourceIsGolBrand) {
      window.location.href = golUrl;
      return;
    }

    window.location.href = getLink('home');
  }

  const handleRedirectPromotional = () => {
    window.location.href = getLink('promocao', { skipQueryParams: true });
  }

  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.ACCOUNT_UNDER_REVIEW)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalCircle />
            </div>
            <p className="modal-title">{t('modal_account_under_review.title')}</p>
            <p className="modal-subtitle">
              {t('modal_account_under_review.description')}
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <SmlsButton text={t('modal_account_under_review.hyperlink')} color="hyperlink" onClick={redirectToHome} />
        <SmlsButton className="button" text={t('modal_account_under_review.button')} onClick={handleRedirectPromotional} />
      </ModalFooter>
    </SmlsModal>
  );
}
